import { useEffect } from "react";
import "./Numeros.css";

function Numeros() {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const target = entry.target;
                    const finalValue = parseInt(target.getAttribute("data-value"), 10);
                    let count = 0;

                    if (target.textContent !== `+${finalValue}`) { // Evita sobrescrever incorretamente
                        const interval = setInterval(() => {
                            if (count < finalValue) {
                                count += Math.ceil(finalValue / 50);
                                target.textContent = `+${count > finalValue ? finalValue : count}`;
                            } else {
                                clearInterval(interval);
                            }
                        }, 30);
                    }
                }
            });
        });

        document.querySelectorAll(".count-up").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);


    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll(".card-numeros, .numeros-titulo").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);


    return (
        <div className="container-inicial container-numeros">
            <h3 className="numeros-titulo d-none" aria-hidden="true">Números que falam por nós</h3>
            <div className="cards-numeros">
                <div className="card-numeros">
                    <span className="numero count-up" data-value="7" aria-label="7 anos de experiência">+0</span>
                    <span className="descricao">anos de experiência</span>
                </div>
                <div className="card-numeros">
                    <span className="numero count-up" data-value="20" aria-label="20 serviços oferecidos">+0</span>
                    <span className="descricao">serviços oferecidos</span>
                </div>
                <div className="card-numeros">
                    <span className="numero count-up" data-value="100" aria-label="100 clientes atendidos">+0</span>
                    <span className="descricao">clientes atendidos</span>
                </div>
                <div className="card-numeros">
                    <span className="numero count-up" data-value="300" aria-label="300 serviços realizados">+0</span>
                    <span className="descricao">serviços realizados</span>
                </div>
            </div>
        </div>
    );
}

export default Numeros;
